import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs';
import {DeviceStatusModel} from 'shared/definition';

@Injectable()
export class SubjectService {
  treeDeviceSubject = new Subject<any>();
  deviceStatusSubject = new Subject<Array<{ deviceSN: string, isOnline: boolean, isAlarm: boolean }>>();
  subcribeListSubject = new Subject<any[]>();
  refreshProjectListSubject = new Subject<boolean>();
  confirmedAlarmsSubject = new Subject<Array<string>>();
  deviceInfoChanged$ = new Subject<string>();
  userPermissionsSubject = new Subject<{new :Array<string>; remove:Array<string>}>();
  alamrsNumber$ = new Subject<number>();
  onDestroy = new Subject();
  private deviceSNList: string[];
  private deviceList: any[];

  private subscribeData: any[] = [];

  setConfirmedAlarmsSubject(alarmIds: Array<string>) {
    this.confirmedAlarmsSubject.next(alarmIds);
  }

  getConfirmedAlarmsSubject(): Observable<any> {
      return this.confirmedAlarmsSubject.asObservable();
  }
  
  setUserPermissionsSubject(permissions: { new :Array<string>; remove:Array<string> }) {
    this.userPermissionsSubject.next(permissions);
  }

  getUserPermissionsSubject(): Observable< { new :Array<string>; remove:Array<string> }> {
      return this.userPermissionsSubject.asObservable();
  }


  sendDeviceList(devices: DeviceStatusModel[]) {
    this.subcribeListSubject.next(devices);
  }

  get devices(): any[] {
    return this.deviceList;
  }

  sendRefreshProjectListSubject(isRefresh: boolean) {
    this.refreshProjectListSubject.next(isRefresh);
  }

  getRefreshProjectListSubject(): Observable<boolean> {
    // return (new Subject<boolean>()).pipe(switchMap(()=> this.refreshProjectListSubject));
    return this.refreshProjectListSubject;
  }

  setDeviceStatus(deviceStatuses: Array<{ deviceSN: string, isOnline: boolean, isAlarm: boolean }>) {
    this.deviceStatusSubject.next(deviceStatuses);
  }

  getDeviceStatus(): Observable<Array<{ deviceSN: string, isOnline: boolean, isAlarm: boolean }>> {
    return this.deviceStatusSubject.asObservable();
  }

  setDeviceInfoChanged(deviceId: string) {
    this.deviceInfoChanged$.next(deviceId);
  }

  getDeviceInfoChanged(): Observable<string> {
    return this.deviceInfoChanged$.asObservable();
  }
  
  get deviceSNs(): string[] {
    return this.deviceSNList;
  }

  set deviceSNs(value: string[]) {
    this.deviceSNList = value;
  }
  getAlarmsNumber(){
    return this.alamrsNumber$.asObservable();
  }
  setAlarmsNumber(number: number){
    this.alamrsNumber$.next(number);
  }
  setSubscribeList(subData: any) {
    if (!this.subscribeData) {
      this.subscribeData = [];
    }
    this.subscribeData.push(subData);
  }

  clearSubscribeList() {
    this.onDestroy.next();
    this.onDestroy.complete();
    if (this.subscribeData) {
      this.subscribeData.forEach(element => {
        element.unsubscribe();
      });
      this.subscribeData = [];
    }
  }

}
